import { pendingChangesGuard } from '../core/guards/pending-changes.guard';

export const GUARD_REGISTRY: Record<string, unknown> = {
  pendingChangesGuard: pendingChangesGuard,
};
